import useGetParsedCvData from './useGetParsedCvData';

export default useGetParsedCvData;
